export namespace NConfirmDeletingElement {
  export type Main = (props: {
    modalOpen: boolean;
    setModalOpen: (status: boolean) => void;
    handleDelete: () => void;
    content: string | JSX.Element;
    title: string;
    isStageDeletionLoading?: boolean;
    modalDataTestId?: string;
    titleDataTestId?: string;
    descriptionDataTestId?: string;
    okText?: string;
    modalType?: ModalType;
  }) => JSX.Element;

  export enum ModalType {
    Delete = 'delete',
    Restore = 'restore',
  }
}
